/* eslint-disable */

export const enum DistributedCacheSubject {
  salesforce = 0,
  customer = 1,
  user = 2,
}
